module.exports = __webpack_public_path__ + "img/cu.750c91b2.svg";